<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col md="2" style="padding:0">
            <Menu/>
          </b-col>
          <b-col md="10" style="padding:0" align="center">
            <b-row>
              <b-col style="margin-left:30px;text-align:left;position:relative">         
                <template>
                  <b-dropdown left split text="language" class="language-dropdown" toggle-class="toggle-language" split-class="split-language" style="font-size: 12px;">
                    <template #button-content>
                      <img
                        :src="currentLanguageFlag"
                        style="width:28px; height:19px; border-radius:2px;"
                      >
                    </template>

                    <!-- Dropdown Items -->
                    <b-dropdown-item @click="selectLanguage('en')">
                      <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                      English
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('fr')">
                      <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                      Français (French)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('de')">
                      <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                      Deutsch (German)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('es')">
                      <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                      Español (Spanish)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('it')">
                      <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                      Italiano (Italian)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-col>
              <b-col>
                <p class="w-pagetitle" style="margin-left:20px;margin-right:20px; margin-top: 10px; text-align:right;">{{ translate("archive") }}</p>
              </b-col>
            </b-row>
            <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b><span style="color: black">CELLAR</span></h1>
            <b-row class="justify-content-center" style="position:relative; top:-15px">
              <p class="t-title">{{ translate("overview of bottles you once had") }}</p>
            </b-row>
            <b-row class="justify-content-center">
              <p class="t-subtitle">{{ translate("to select one, click") }}</p>
            </b-row>
              <!-- Search / Filter -->
              <b-form class="w-search" style="width:70%; margin:0 auto" @submit.prevent>
                <br>
                <b-form-group>
                  <b-form-input
                    id="input-search"
                    class = "w-input"
                    style = "background-color:white !important; padding-left: 40px"
                    v-model="search_text"
                    aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>              
                </b-form-group>

                <div style="width:20px; position: relative; float:left; top: -39px; left: 10px; margin: 0; padding:0">
                  <font-awesome-icon 
                    style="font-size:17px;color: rgb(109,122,82);" 
                    icon="search" />
                </div>

                <!-- Counts -->
                <div class="w-results-toolbar">
                  <div class="w-results-count">
                    {{ translate("showing") }} {{ filteredEntries.length }} {{ translate("archived bottles") }}  
                  </div>
                </div>
              </b-form> 

              <!-- Results -->
              <b-row class="justify-content-center" style="margin:0">              
                <b-col
                  v-for="(entry, index) in visibleEntries"
                  v-bind:item="entry"
                  v-bind:index="index"
                  v-bind:key="entry._id" 
                  class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                  xs="12" sm="6" md="4" lg="2" xl="2"
                  style ="display:block; min-width:300px; margin:20px !important"
                >
                  <b-row 
                    style="width:100%"
                    v-on:click="onSelect(entry._id)"
                  >
                    <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                      <b-img center v-if="entry.image_files[0]"
                        style="height:100%;width:auto;position:absolute;right:0px"
                        v-bind:src="entry.image_files[0].dataURL" 
                      ></b-img>
                      <b-img center v-else
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/bottle.png')"
                      ></b-img>
                    </b-col>
                    <b-col cols="9" class="d-table-cell">
                      <div>
                        <p class="t-title">{{entry.vintage}}</p>
                        <p class="t-title2">{{entry.name}}</p>
                        <p class="t-subtitle" v-if="entry.type">{{entry.type}}</p>
                        <p class="t-subtitle" style="color:white" v-else>bogus text here</p>
                        <hr style="margin:5px 0 5px 0">
                        <p class="t-text" v-if="entry.appellation">{{entry.appellation}}</p>
                        <p class="t-smalltext" v-if="entry.classification">{{entry.classification}}</p>
                        <p class="t-smalltext" v-if="entry.color">{{entry.color}}</p>
                        <p class="c-bottles" style="font-size: 11px">{{ translate("archived") }}: {{entry.archived_date}}</p>
                        <!-- <p class="c-bottles" style="font-size: 11px">archived: {{formatDate(entry.archived_date)}}</p> -->
                      </div>
                      <b-button pill
                        v-if="entry.number == 0"
                        style="top:10px"
                        class="delete-button"
                        v-on:click.stop="onDelete(index)"
                        v-b-tooltip.hover :title="translate('delete entry')"
                      >
                        <font-awesome-icon class="delete-symbol" icon="trash-alt" />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br>
              <Paginator
                v-model="current_page"
                :total-rows= "filteredEntries.length"
                :per-page.sync="per_page"
              />
          </b-col>
        </b-row>
        <br>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>

    <b-modal id="deleteEntry" ref="deleteEntry" title="delete entry" @ok="deleteEntry"> 
      <b-row v-if="current_index >=0">
        <div style="width:300px;margin-left:auto;margin-right:auto">
          <b-col
            class="w-tile m-2 d-inline-flex justify-content-center"
            style ="display:block; margin:20px !important"
          >
            <b-row 
              style="width:100%"
            >
              <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                <b-img center v-if="visibleEntries[current_index].image_files[0]"
                  style="height:100%;width:auto;position:absolute;right:0px"
                  v-bind:src="visibleEntries[current_index].image_files[0].dataURL" 
                ></b-img>
                <b-img center v-else
                  style="height:100%;width:auto;position:absolute;right:0px"
                  :src="require('@/assets/img/bottle.png')"
                ></b-img>
              </b-col>
              <b-col cols="9" class="d-table-cell">
                <div>
                  <p class="t-title">{{visibleEntries[current_index].vintage}}</p>
                  <p class="t-title2">{{visibleEntries[current_index].name}}</p>
                  <p class="t-subtitle" v-if="visibleEntries[current_index].type">{{visibleEntries[current_index].type}}</p>
                  <hr>
                  <p class="t-text" v-if="visibleEntries[current_index].appellation">{{visibleEntries[current_index].appellation}}</p>
                  <p class="t-text" v-if="visibleEntries[current_index].classification">{{visibleEntries[current_index].classification}}</p>
                  <p class="c-bottles">{{visibleEntries[current_index].number}}</p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-row>
      <p class="t-subtitle text-center">{{ translate("deleting the entry is also deleting all transactions and tasting notes of the entry") }}</p>
      <p class="t-title text-center">{{ translate("ARE YOU SURE YOU WANT TO DELETE THIS ENTRY?") }}"</p>
      
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">  
          <b-col class="text-left">
            <b-button class="w-button-pink" @click="cancel()">
              cancel
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button class="w-button-green" @click="ok()">
              ok
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script> 
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";

  import {wordlist,translate_word} from '../assets/js/translate.js';

  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuDesktop.vue';
  import Paginator from "@/components/Paginator.vue";

  import Users from '../Users.js';
  import Cellars from '../Cellars.js'
  import Entries from '../Entries.js'

  import Transactions from '../Transactions.js'
  import TastingNotes from '../TastingNotes.js'

  import formatDate from '../assets/js/formatDate.js';

  export default {
    name: "Archive",
    components: {
      vSelect,
      NoAccess,
      Menu,
      Paginator,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },

      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      }, 

      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },

      currentCellarID() {
        return this.$store.state.cellar_id
      },
      currentCellar() {
        return this.$store.state.cellar
      },
      currentCellarLoaded() {
        return this.$store.state.cellar_loaded
      },

      filteredEntries() {
        if (!this.search_text) {
          return this.entries
        }
        const keywords = this.search_text
          .toLowerCase()
          .trim()
          .split(/\s+/)
        return this.entries.filter(entry => {
          const text = [
            entry.name,
            entry.type,
            entry.country,
            entry.region,
            entry.appellation,
            entry.classification,
            entry.color,
            entry.grapes,
            entry.vintage,
            entry.image_files
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase()

          // Every keyword must be present
          return keywords.every(keyword => text.includes(keyword))
        })
      },

      visibleEntries() {
        const start = (this.current_page - 1) * this.per_page
        return this.filteredEntries.slice(
          start,
          start + this.per_page
        )
      }
    },
    watch: {
      search_text() {
        this.current_page = 1
      },
      search_text: "saveSearchState",
    },
    data() {
      return {
        debug: false,
        
        isLoading: true,

        cellar: {},
        cellar_id:0,
        
        entries: [],
        error: '',
        isValid: true,

        current_index: -1,

        search_text:"",
        current_page: 1,
        per_page:6,
      }
    }, 
    async mounted() {
      let local_debug = false
      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("Archive.mounted: START")

      // Load the Cellar
      if (this.currentCellarLoaded) {
        if (local_debug || this.debug) console.log("Archive.mounted: CURRENT CELLAR LOADED")
        this.cellar = this.currentCellar
        this.cellar_id = this.currentCellarID
        if (local_debug || this.debug) console.log("Archive.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully retrieved from store.")
      }
      else {
        if (local_debug || this.debug) console.log("Archive.mounted: CURRENT CELLAR NOT LOADED - QUERYING THE DATABASE")
        this.cellar_id = this.$route.query.cellar_id
        await Cellars.getone(this.cellar_id)
        .then(response => {
          this.cellar = response
          delete this.cellar._id
          if (local_debug || this.debug) console.log("Archive.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully fetched from DB.")
        })
        .catch(error =>{
          if (local_debug || this.debug) console.log("Archive.mounted: catch Cellar.getone with error: ", error)
        })

        this.$store.commit('setCellar',this.cellar)
        this.$store.commit('setCellarID',this.cellar_id)
        this.$store.commit('setCellarLoaded',true)

        if (local_debug || this.debug) console.log("Archive.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully stored in store.")
      }

      if (this.$route.query.source_page) this.source_page = this.$route.query.source_page
      if (this.source_page === "Archive") {
        const searchState = this.$store.getters.currentSearchState

        this.search_text = searchState.search_text
        this.entries = searchState.entries
      } else {
        this.search_text = ""
        this.entries = []
      }

      if (this.entries.length === 0) {
        // Load the archived entries
        if (this.cellar_id !== 0 && this.cellar.archive_ids?.length > 0) {
          const validEntryIds = this.cellar.archive_ids.filter(
            id => typeof id === "string" && id.length === 24
          )

          Entries.getmany(validEntryIds)
            .then(entries => {
              if (!Array.isArray(entries)) {
                throw new Error("Archive.mounted: Entries.getmany() did not return an array")
              }
              this.entries = entries
                .filter(entry => entry && typeof entry === "object")
                .sort((a, b) => {
                  const dateA = a.archived_date || ""
                  const dateB = b.archived_date || ""

                  return dateB.localeCompare(dateA)
                })

                if (local_debug || this.debug) console.log("Archive.mounted:", this.entries.length, "entries successfully fetched from DB")
            })
            .catch(error => {
              if (local_debug || this.debug) console.error(
                "Archive.mounted: failed to load archived entries",
                error
              )
              this.entries = []
              this.$bvToast?.toast(
                "Unable to load archived entries.",
                {
                  title: "Database Error",
                  variant: "danger",
                  solid: true
                }
              )
            })
        }
      }

      this.isLoading = false
      if (local_debug || this.debug) console.log( "Archive.mounted: STOP")
    },
    methods: {
      onSelect(entry_id) {
        if (this.debug) console.log("Archive in onSelect: entry_id = ", entry_id);
        this.$store.commit('setPage','EntryShow')
        this.$router.push({path:'/EntryShow', query: {cellar_id:this.$route.query.cellar_id,niche_id:this.$route.query.niche_id, entry_id:entry_id }});
      },

      async onDelete(i) {
        let local_debug = true
        this.current_index = i
        if (local_debug || this.debug) console.log("Delete Pressed i = "+ i)
        if (local_debug || this.debug) console.log("this.visibleEntries[i] = ", JSON.stringify(this.visibleEntries[i]))
        await this.$bvModal.show('deleteEntry')
      },
      
      async deleteEntry(){
        let local_debug = true

        if (local_debug || this.debug) console.log("")
        if (local_debug || this.debug) console.log("Archive.deleteEntry: START")
        let this_entry_id = this.visibleEntries[this.current_index]._id
        if (local_debug || this.debug) console.log("Archive.deleteEntry: this_entry_id=",this_entry_id)

        // Delete all correcponding tranactions of the entry in the database
        for (let i = 0 ; i < this.entries[this.current_index].transaction_ids.length ; i++) {
          await Transactions.delete(this.entries[this.current_index].transaction_ids[i])
          .then(response => {
            if (local_debug || this.debug) console.log("Archive.deleteEntry: entry transaction with id ", this.entries[this.current_index].transaction_ids[i], " deleted with response : ", response)
          })
          .catch(error => {
            if (local_debug || this.debug) console.log('Archive.deleteEntry: catch await Transactions.delete ERROR : ' + error);
          })
        }
        // Delete all corresponding tasting notes of the entry in the database
        for (let i = 0 ; i < this.entries[this.current_index].tasting_note_ids.length ; i++) {
          await TastingNotes.delete(this.entries[this.current_index].tasting_note_ids[i])
          .then(response => {
            if (local_debug || this.debug) console.log("Archive.deleteEntry: entry tasting note with id ", this.entries[this.current_index].tasting_note_ids[i], " deleted with response : ", response)
          })
          .catch(error => {
            if (local_debug || this.debug) console.log('Archive.deleteEntry: catch await TastingNotes.delete ERROR : ' + error);
          })
        }
        
        // Delete the entry in the database
        await Entries.delete(this_entry_id)
        .then(response => {
          if (local_debug || this.debug) console.log("Archive.deleteEntry: entry with id ", this_entry_id, " deleted with response : ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('Archive.deleteEntry: catch await Entries.delete ERROR : ' + error);
        })

        // Update cellar archive in the database
        for (let i=0 ; i < this.cellar.archive_ids.length ; i++) {
          if (this.cellar.archive_ids[i] == this_entry_id) {
            this.cellar.archive_ids.splice(i,1)
            break
          }
        }
        if (local_debug || this.debug) console.log("Archive.deleteEntry: entry with id ", this_entry_id, " removed from this.cellar.archive_ids")
        
        await Cellars.update(this.cellar_id,this.cellar)
        .then(response => {
          if (local_debug || this.debug) console.log("Archive.deleteEntry: cellar ",this.cellar," with id ", this.cellar_id, " updated with response : ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('Archive.deleteEntry: catch await Cellars.update ERROR : ' + error);
        })

        // Update cellar in the store
        this.$store.commit('setCellar',this.cellar)
        if (local_debug || this.debug) console.log("Cellar.deleteNiche: cellar ", this.cellar_id, " updated in store")

        // Update Entries locally
        if (local_debug || this.debug) console.log("Archive.deleteEntry: entry with id ", this.entries[this.current_index]._id, " removed from entries")
        this.entries.splice(this.current_index,1);
        this.current_index = -1;

        if (local_debug || this.debug) console.log("Archive.deleteEntry: STOP")
      },

      saveSearchState() {
        this.$store.commit("setSearchState", {
          search_text: this.search_text,
          entries: this.entries
        })
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
        })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },
      
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
    }
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.w-bottomright {
  position:absolute;
  bottom: 10px;
  right: 5px;
  margin:0;
}
.w-big {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0 !important;
}
.w-text {
  font-size: 10px;
  margin:0;
}

.w-white-button {
  background-color: white;
  border-color: grey;
  color: grey;
  width: auto;

  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.w-white-button:hover {
  background-color: #6d7a52;
  border-color: #6d7a52;
  color: white;
}
</style> 